import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { NavService } from '../../../services/nav.service';
import { DialogService } from '../../../services/dialog.service';
import { ConfirmDialogData } from '../dialog/confirm/confirm.component';
import { AuthService } from '../../../services/auth.service';
import { HelpersService } from '../../../services/helpers.service';
import { NotificationService } from '../../../services/notification.service';
import { NgIf } from '@angular/common';
import * as Global from '../../../global';
import { NgxSpinnerService } from 'ngx-spinner';
import { PermissionsService } from '@app/services/permissions.service';
import { UserService } from '../../../services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { TeamListComponent } from '../dialog/team-list/team-list.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    NgIf
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  Global = Global
  @Input() isMobileNavOpen: boolean = false;
  @Input() isMobileNav: boolean = false;
  @Input() isNavOpen: boolean = true;
  userDetails: any = null;
  count: any = null;
  assignedEmployee: any = null
  claims: any = []
  constructor(
    public notification: NotificationService,
    public navService: NavService,
    private dialogService: DialogService,
    private authService: AuthService,
    private helpers: HelpersService,
    public permissions: PermissionsService,
    private spinner: NgxSpinnerService,
    private userService: UserService,
    private dialog: MatDialog
  ) {
    this.userDetails = this.helpers.userDetails();
  }
  async ngOnInit() {
    this.notification.getCount().subscribe((count: any) => {
      this.count = count;
    });
    this.claims = await this.permissions.getAllClaims();
  }
  toogleNav() {
    this.navService.updateNav(!this.isNavOpen);
  }
  toogleMobileMenu() {
    this.navService.setIsMobileNavOpen(!this.isMobileNavOpen);
  }
  signOut(): void {
    const dialogData: ConfirmDialogData = {
      title: 'Are you sure?',
      message: 'You want to sign out?',
      saveText: 'Sign Out',
      cancelText: 'Cancel',
    };
    this.dialogService.confirmDialog(dialogData).subscribe((result: any) => {
      if (result?.confirm) {
        this.authService.userLogout();
      }
    });
  }
  assignedEmployeeCount() {
    this.notification.assignedEmployeeCount({}).subscribe({
      next: (res: any) => {
        this.assignedEmployee = res?.data ?? null
      },
      error: (err: any) => {

      }
    })
  }
  openTeamList() {
    this.dialog.open(TeamListComponent, {
      width: '1000px',
      maxWidth: '95vw',
      autoFocus: false,
      data: { userId: this.helpers.userId() },
    });
  }
  downloadUserManual() {
    this.spinner.show();
    this.userService.downloadUserManual().subscribe({
      next: (res: any) => {
        if (res?.download) {
          const fileName = res?.download.split(/[\\/]/).pop();
          const src = Global.BACKEND_URL + '/' + res?.download; // Adjust the MIME type according to your file type
          const link = document.createElement('a');
          link.href = src;
          link.download = fileName;
          link.click();
          link.remove();
        }
      },
      error: (err: any) => {
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
}
